<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">
      <div class="title">
        {{ newInfo.title }}
      </div>
      <div class="showInfo">
        <span class="split">
          <img src="/image/icon/shizhong.png" />
          {{ formatter(newInfo.publishtime, 'en') }}
        </span>
        <!-- <span class="split"> author: </span> -->
        <span class="split"
              v-if="newInfo.source != ''">
          source:
          <a :href="newInfo.source"
             target="_blank">
            {{ newInfo.source }}
          </a>
        </span>
        <span class="split"> views:{{ newInfo.clickVolume }} </span>
      </div>
      <div class="mainTextWrap">
        <p v-html="contents"></p>
        <!-- <p :class="{ mainText: item.sign == 'mainText', maintitle: item.sign == 'maintitle', mainImg: item.sign == 'mainImg' }" v-for="(item, index) in apiData.content" :key="'0' + index">
                    <img :src="item.main" v-if="item.sign == 'mainImg'" />
                    <span v-if="item.sign != 'mainImg'">{{ item.main }}</span>
                </p>-->
        <div class="downInfor marginTop50">
          <!-- <p><span>Title：</span>ecause they have been doing this themselves for hund</p>
                    <p>
                        <span>Link：</span> <a href="#">{{ apiData.link }}</a>
                    </p> -->
          <p><span></span>{{ newInfo.disclaimer }}</p>
        </div>
      </div>
      <div class="timeLine">
        <div class="flex1 display_between">
          <div class="display_center tipsHover"
               v-if="lastNew.id > 0"
               @click="clkNew(lastNew)">
            <div class="page_btn"
                 style="margin-right: 10px;">
              &lt;
            </div>
            <div>
              <a href="javascript:;"
                 class="page_btn_active_link"><span style="font-weight: bold;">Previous：</span>{{ ellipsis(lastNew.title, 60) }}</a>
            </div>
          </div>
          <div class="display_center tipsHover"
               v-if="nextNew.id > 0"
               @click="clkNew(nextNew)">
            <div>
              <a class="page_btn_active_link"
                 href="javascript:;"><span style="font-weight: bold;">Next：</span> {{ ellipsis(nextNew.title, 60) }}</a>
            </div>
            <div class="page_btn page_btn_active"
                 style="margin-left: 10px;">
              &gt;
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from '../home/breadcrumbPage';
export default {
  name: 'enInforDetail',
  components: {
    breadcrumbPage
  },
  data () {
    return {
      apiData: {},
      newInfo: {},
      contents: '',
      lastNew: {
        id: 0,
        title: ''
      },
      nextNew: {
        id: 0,
        title: ''
      },
      column_Type: 0,
      courseList: [] //推荐课程
    };
  },
  created () {
    this.column_Type = parseInt(this.$route.query.column_Type);
    this.GetNewInfoById(this.$route.query.id, this.$route.query.column_Type);
    this.getData();
  },
  methods: {
    getData () {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          that.apiData = data.enInforDetail;
        })

    },
    //根据新闻ID获取新闻详情
    GetNewInfoById (id, column_Type) {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetNewInfoById', {
          keyword: '',
          id: parseInt(id),
          parentID: 0,
          column_Type: parseInt(column_Type),
          pageIndex: 0,
          pageSize: 0
        })
        .then(res => {
          if (res.data.code == 200) {
            let newinfolist = res.data.data.gpSiteNewInfoViewsViews;
            if (newinfolist != null && newinfolist.length > 0) {
              _this.newInfo = newinfolist[0];
              // _this.contents = _this.newInfo.contents
              _this.contents = _this.newInfo.contents.replace(/white-space:nowrap/g, 'white-space:pre-wrap');
            }
            _this.lastNew = res.data.data.lastNextPieceNewViews[0];
            _this.nextNew = res.data.data.lastNextPieceNewViews[1];
          }
        });
    },
    clkNew (e) {
      var title = this.$route.query.urltitle;
      var type = this.column_Type;
      this.GetNewInfoById(e.id, type);
      this.$router.push({
        path: 'enInforDetail?',
        query: {
          urltitle: title,
          id: e.id,
          column_Type: type
        }
      });
    }
  }
};
</script>

<style scoped>
.content {
    padding-top: 30px;
    flex: 1;
    padding-bottom: 50px;
}
.title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
}
.showInfo {
    height: 54px;
    border-bottom: 1px solid #ddd;
    line-height: 54px;
}
.split {
    font-size: 16px;
    position: relative;
    margin-right: 20px;
}
.split ~ .split::before {
    content: '|';
    margin: 0 14px;
    color: #ddd;
    position: absolute;
    left: -28px;
}
.mainTextWrap {
    padding-top: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #ddd;
}
.maintitle {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 15px;
}
.mainText {
    font-size: 18px;
    margin-bottom: 44px;
}
.downInfor {
    font-size: 18px;
}
.downInfor p {
    margin-bottom: 16px;
}
.downInfor span {
    font-weight: bold;
}
.downInfor a {
    color: #8cb9b9;
}
.timeLine {
    height: 80px;
    line-height: 80px;
}
.page_btn {
    color: #999;
    cursor: pointer;
    display: inline-block;
    width: 22px;
    height: 22px;
    text-align: center;
    line-height: 22px;
    border-radius: 22px;
    border: 1px solid #ccc;
}
.page_btn_active {
}
.page_btn_active_link {
}
.tipsHover:hover .page_btn_active_link {
    color: #0b8686;
}
.tipsHover:hover .page_btn {
    background: #0b8686;
    color: #fff;
    border: 1px solid #0b8686;
}
</style>
